import { LRLanguage } from "@codemirror/language";
import { parser as htmlParser } from "@lezer/html";
import { parseMixed } from "@lezer/common";
import { twigLanguage } from "@ssddanbrown/codemirror-lang-twig";
import { html } from "@codemirror/lang-html";

// Twig language that supports HTML/Twig mixed content

const mixedHtmlParser = htmlParser.configure({
  wrap: parseMixed(node => {
    if (!node.type.isTop) return null;

    return {
      parser: twigLanguage.parser,
      overlay: node => {
        const text = node.type.name;
        return text === "Text" || text === "PlainText";
      }
    };
  })
});

export const mixedHtmlTwigLanguage = LRLanguage.define({
  parser: mixedHtmlParser,
  name: "Twig"
});

export function twigHtml() {
  return [mixedHtmlTwigLanguage, html().support];
}
